module.exports = __webpack_public_path__ + "static/media/einstein-inactive.b795a6bb.svg";